import {noop} from 'lodash';
import {HttpResponseMessage} from "aurelia-http-client";

export function preserveRequest<T extends Promise<HttpResponseMessage>, R>(promise: T, consumer: (promise: T) => Promise<R>) {
  return wrap(promise, consumer(promise));
}

export function responseContent(promise: Promise<HttpResponseMessage>) {
  return promise.then(msg => msg.content);
}

export function handleResponse<T extends Promise<HttpResponseMessage>, R>(promise: T, consumer?: (promise: Promise<any>) => Promise<any>) {
  return preserveRequest(promise, $promise => {
    const contentPromise = responseContent($promise);
    return consumer ? consumer(contentPromise) : contentPromise;
  });
}

export function preserveDummyRequest<T>(promise: Promise<T>) {
  return wrap({abort: noop}, promise);
}

function wrap<T, K>(request: T, response: K) {
  return {request, response};
}
